import { RadioGroup } from './components/RadioGroup';

export default RadioGroup;
